export default class Validate {

	  static email(email){
	    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	    return emailRegex.test(email);
	  };
	
	
	  static phone(phone){
		  const phoneRegex = /^\d{10}$/;
		  return phoneRegex.test(phone);
	  };  

}